<template>
  <div>
    <a-descriptions bordered size="small" :title="item.pName" :column="3" v-for="item in parameTabsList">
      <a-descriptions-item :label="item2.name" v-for="(item2, index2) in item.children" :key="index2">{{ item2.vaules }}</a-descriptions-item>
    </a-descriptions>
  </div>
</template>
<script>

export default {
  props: {
    model: Object,
    parameTabsList: Array
  },
  watch: {
    model: {
      handler (model) {
        console.log('watch_record', model)
        // this.initDetail(model)
      },
      immediate: true
    }
  },
  data () {
    return {
      detail: {}
    }
  },
  methods: {
    initDetail (model) {
    }
  }
}
</script>
<style scoped>
</style>